import { render, staticRenderFns } from "./rop_form.vue?vue&type=template&id=685b04f2"
import script from "./rop_form.vue?vue&type=script&lang=js"
export * from "./rop_form.vue?vue&type=script&lang=js"
import style0 from "./rop_form.vue?vue&type=style&index=0&id=685b04f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports